module.exports = __webpack_public_path__ + "media/images/pc/specials/common/special_c_08-e75c116d893c9a1641eeaddbf52d13c1.png";